export default "__VITE_ASSET__ji$3w7Ff__"